// cssのブレークポイント登録。必要に応じて名前つきインポートして利用
// https://jsprimer.net/basic/module/

export const mediaQuerySm = window.matchMedia('(min-width: 576px)');
export const mediaQueryMd = window.matchMedia('(min-width: 811px)');
export const mediaQueryLg = window.matchMedia('(min-width: 1025px)');
export const mediaQueryXl = window.matchMedia('(min-width: 1366px)');
export const mediaQueryXxl = window.matchMedia('(min-width: 1600px)');